import blockedNumbersService from '../../services/api/BlockedNumbers';
import commonFunctions from '../../mixin/common-function-mixins';
import { BLOCKED_AND_WHITELIST_NUMBERS_ACTION, BLOCKED_OR_WHITELIST_NUMBER_DELETE_ACTION, BLOCKED_OR_WHITELIST_NUMBER_SAVE_ACTION
  }  from '../action-types';
import {BLOCKED_AND_WHITELIST_NUMBERS_MUTATION, BLOCKED_OR_WHITELIST_NUMBER_CHANGED_MUTATION, 
  BLOCKED_OR_WHITELIST_NUMBER_TYPE_CHANGED_MUTATION, BLOCKED_OR_WHITELIST_NUMBER_CLEAR_DATA_MUTATION,
  BLOCKED_OR_WHITELIST_NUMBER_CANCEL_CHANGED_MUTATION, WHITELIST_NUMBER_DATA_CHANGED_MUTATION, WHITELIST_NUMBER_REVERT_DATA_MUTATION, 
  WHITELIST_NUMBER_IS_ROW_DATA_MODIFIED_BUTTON_MUTATION, WHITELIST_NUMBER_NOTES_CHANGED_MUTATION, WHITELIST_NUMBER_REMOVE_DATA_MUTATION,
  WHITELIST_NUMBER_DISABLED_EDIT_FIELDS_DATA_MUTATION, WHITELIST_NUMBER_IS_DATA_LOADING_MUTATION,
  WHITELIST_NUMBER_SPINNER_MUTATION, WHITELIST_NUMBER_MAPPED_OLD_TO_NEW_DATA_MUTATION, BLOCKED_OR_WHITELIST_NUMBER_AUDIT_LOG_MUTATION} from '../mutation-types';

export const namespaced = true;

// initial state
export const state = {
  namespaced: true,
  isCheckBlockedNumber: false,
  isCheckWhitelistedNumber: false,
  blockedAndWhitelistNumbersSummaryData: [],
  blockedNumberslist: [],
  whitelistNumbers: [],
  blockedAndWhitelistNumber: loadEmptyBlockedAndWhitelistNumber(),
  isFieldDisabled: false,
  isDataLoading: false,
  oldWhiteListNumberList : [],
};


// actions
export const actions = {  
    async [BLOCKED_AND_WHITELIST_NUMBERS_ACTION]({ commit },param) {
        const responsedata = await blockedNumbersService.getBlockedAndWhitelistNumbers();
        var response = commonFunctions.methods.sortRecords(responsedata.data, 'createdDate', false );
        commit(BLOCKED_AND_WHITELIST_NUMBERS_MUTATION, {blockedAndWhitelistNumbersSummaryData : response, param});
        return response.data;
      },
    async [BLOCKED_OR_WHITELIST_NUMBER_DELETE_ACTION]({state}, BlockedOrWhitelistNumberDetails){
      var tazClientAuditLog = state.blockedAndWhitelistNumber.tazClientAuditLog;
      state.blockedAndWhitelistNumber = BlockedOrWhitelistNumberDetails;
      state.blockedAndWhitelistNumber.tazClientAuditLog = tazClientAuditLog;
      const response = await blockedNumbersService.deleteBlockedOrWhitelistNumber(state.blockedAndWhitelistNumber);
      return response;
    },
    async [BLOCKED_OR_WHITELIST_NUMBER_SAVE_ACTION] ({commit, state},whitelistData){ 
      commit(WHITELIST_NUMBER_IS_DATA_LOADING_MUTATION, {isDataLoading: true, isAdd: whitelistData.isAdd});
      const response = await blockedNumbersService.saveBlockedOrWhitelistNumber(((whitelistData && whitelistData.summaryRowData) && whitelistData.summaryRowData.length > 0) ? whitelistData.summaryRowData : [state.blockedAndWhitelistNumber]);  
      if(whitelistData && whitelistData.isAdd) {
        var responsedata = commonFunctions.methods.sortRecords(response.data, 'createdDate', false );
        commit(BLOCKED_AND_WHITELIST_NUMBERS_MUTATION, {blockedAndWhitelistNumbersSummaryData: responsedata})
        commit(WHITELIST_NUMBER_IS_DATA_LOADING_MUTATION, {isDataLoading: false, isAdd: whitelistData.isAdd})
      }
      else
        commit(WHITELIST_NUMBER_MAPPED_OLD_TO_NEW_DATA_MUTATION ,{state, whitelistData: whitelistData.summaryRowData})
      return response;
    }
}
// mutations
export const mutations = { 
    [BLOCKED_AND_WHITELIST_NUMBERS_MUTATION](state, payLoad ){
      payLoad.blockedAndWhitelistNumbersSummaryData.map(row=>{
        if(!row.createdBy)
          row.createdBy =' ';
          row.spinner = false;
          row.isRowDataModified = false;
          row.oldPhoneNumber = row.phoneNumber;
          row.oldNotes = row.notes;
      });
      payLoad.blockedAndWhitelistNumbersSummaryData.map(r =>{ r.createdDate = commonFunctions.methods.formatDate(r.createdDate, 'MM/DD/YYYY hh:mm A')});
      state.blockedAndWhitelistNumbersSummaryData = payLoad.blockedAndWhitelistNumbersSummaryData;
      state.blockedNumberslist =  state.blockedAndWhitelistNumbersSummaryData.filter(number => number.numberType == "Blocked");
      if((!payLoad.param || payLoad.param != "Blocked") && (!state.blockedAndWhitelistNumber.numberType || state.blockedAndWhitelistNumber.numberType == "WhiteList"))
        state.whitelistNumbers = state.blockedAndWhitelistNumbersSummaryData.filter(number => number.numberType == "WhiteList");
        state.oldWhiteListNumberList = JSON.parse(JSON.stringify(state.whitelistNumbers));
    },
    [BLOCKED_OR_WHITELIST_NUMBER_CHANGED_MUTATION](state, phoneNumber) {
      state.blockedAndWhitelistNumber.phoneNumber = phoneNumber
    },
    [BLOCKED_OR_WHITELIST_NUMBER_TYPE_CHANGED_MUTATION](state, numberType) {
      state.blockedAndWhitelistNumber.numberType = numberType=="Blocked"?"Blocked":"WhiteList"
      state.isCheckBlockedNumber = numberType == "Blocked"?state.isCheckBlockedNumber=true:state.isCheckBlockedNumber=false ;
      state.isCheckWhitelistedNumber = numberType == "WhiteList"?state.isCheckWhitelistedNumber=true:state.isCheckWhitelistedNumber=false ;
      if(state.blockedAndWhitelistNumber.numberType == "Blocked")
        state.isFieldDisabled = false;
    },
    [BLOCKED_OR_WHITELIST_NUMBER_CLEAR_DATA_MUTATION](state){
      state.blockedAndWhitelistNumber = loadEmptyBlockedAndWhitelistNumber();
      state.isCheckBlockedNumber = false;
      state.isCheckWhitelistedNumber = false;
    },
    [BLOCKED_OR_WHITELIST_NUMBER_CANCEL_CHANGED_MUTATION](state){
      state.isCheckBlockedNumber = false;
      state.isCheckWhitelistedNumber = false;
    },
    [WHITELIST_NUMBER_NOTES_CHANGED_MUTATION](state, notes) {
      state.blockedAndWhitelistNumber.notes = notes
    },
    [WHITELIST_NUMBER_DATA_CHANGED_MUTATION](state, payLoad){
      payLoad.item[payLoad.columnName] = payLoad.value;
    },
    [WHITELIST_NUMBER_MAPPED_OLD_TO_NEW_DATA_MUTATION](state, whitelist){
      whitelist.whitelistData.forEach(element => {
        state.whitelistNumbers.map(r=>{
          if(r.callNumberID == element.callNumberID){
            r.oldPhoneNumber = element.phoneNumber;
            r.oldNotes = element.notes;
          }
        });
      })
      state.oldWhiteListNumberList = state.oldWhiteListNumberList.map((element) => {
        var filteredRow = whitelist.whitelistData.filter(row => row.callNumberID == element.callNumberID);
        if(filteredRow && filteredRow.length > 0 && element.callNumberID  === filteredRow[0].callNumberID) {
          return Object.assign({}, element, filteredRow[0]);
        }
        return element;
      });
    },
    [WHITELIST_NUMBER_SPINNER_MUTATION](state, whiltelistData) {
        whiltelistData.item.map(row => {
          row.spinner = whiltelistData.value;
      })
    },
    [WHITELIST_NUMBER_DISABLED_EDIT_FIELDS_DATA_MUTATION](state, value){
      state.isFieldDisabled = value;
    },
    [WHITELIST_NUMBER_IS_DATA_LOADING_MUTATION](state, payLoad) {
      if(payLoad.isDelete || (payLoad.isAdd && state.blockedAndWhitelistNumber.numberType == "WhiteList")){
          state.isDataLoading = payLoad.isDataLoading;
      }
    },
    [WHITELIST_NUMBER_IS_ROW_DATA_MODIFIED_BUTTON_MUTATION](state, payLoad){
      if(state.whitelistNumbers.some(r=>r.callNumberID == payLoad.item.callNumberID)){
        state.whitelistNumbers.map(r=>{
          if(r.callNumberID == payLoad.item.callNumberID){
            r.isRowDataModified = payLoad.value;
          }
        })
      }
    },
    [WHITELIST_NUMBER_REVERT_DATA_MUTATION](state,item){
      if(state.whitelistNumbers.some(r=>r.callNumberID == item.callNumberID)){
        state.whitelistNumbers.map(r=>{
          if(r.callNumberID == item.callNumberID){
            r.phoneNumber = r.oldPhoneNumber;
            r.notes = r.oldNotes;
            r.isRowDataModified = false;
          }
        })
      }
    },
    [WHITELIST_NUMBER_REMOVE_DATA_MUTATION](state, payLoad){
      state.whitelistNumbers = state.whitelistNumbers.filter(row=>row.callNumberID != payLoad.callNumberID)
    },
    [BLOCKED_OR_WHITELIST_NUMBER_AUDIT_LOG_MUTATION](state, payLoad){
      state.blockedAndWhitelistNumber.tazClientAuditLog = payLoad;
    }
}
function loadEmptyBlockedAndWhitelistNumber() {
  return {
    callNumberID: 0,
    phoneNumber: "",
    numberType: "",
    notes: ""
  }
}